import React, { useState, useRef } from 'react';

const Tooltip = ({ children, content, placement = 'top', className = '' }) => {
  const [visible, setVisible] = useState(false);
  const timeout = useRef();

  const show = () => {
    timeout.current = setTimeout(() => setVisible(true), 200);
  };
  const hide = () => {
    clearTimeout(timeout.current);
    setVisible(false);
  };

  return (
    <span className="relative inline-block" onMouseEnter={show} onMouseLeave={hide} onFocus={show} onBlur={hide}>
      {children}
      {visible && (
        <div
          className={`z-50 absolute whitespace-pre-line px-3 py-2 rounded-lg shadow-lg text-xs font-medium bg-gray-900 text-white border border-gray-700 ${className}
            ${placement === 'top' ? 'bottom-full left-1/2 -translate-x-1/2 mb-2' : ''}
            ${placement === 'bottom' ? 'top-full left-1/2 -translate-x-1/2 mt-2' : ''}
            ${placement === 'left' ? 'right-full top-1/2 -translate-y-1/2 mr-2' : ''}
            ${placement === 'right' ? 'left-full top-1/2 -translate-y-1/2 ml-2' : ''}
          `}
          style={{ minWidth: 180, maxWidth: 320 }}
        >
          {content}
        </div>
      )}
    </span>
  );
};

export default Tooltip; 